export default "__VITE_PUBLIC_ASSET__9619e9bf__"